import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', to: { pathname: '/', hash: '#home' } },
    { label: 'About Us', to: { pathname: '/', hash: '#about' } },
    { label: 'How It Works', to: { pathname: '/', hash: '#how-it-works' } },
    { label: 'Partners', to: { pathname: '/', hash: '#partners' } },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms of Service', to: '/terms-of-service' },
  ];

  return (
    <footer className="bg-slate-900 py-12 text-slate-200">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 lg:flex-row lg:items-start lg:justify-between">
        <div className="space-y-4">
          <p className="text-lg font-semibold text-white">Dial TPR</p>
          <p className="max-w-sm text-sm text-slate-300">
            Call-first delivery service that connects neighbourhood customers with trusted shops. Every order is confirmed with the store and delivered with the original invoice.
          </p>
          <div className="flex gap-3 text-sm text-slate-400">
            <a href="mailto:dailtpr@gmail.com" className="transition hover:text-white">
              dailtpr@gmail.com
            </a>
            <span>•</span>
            <a href="tel:+919176687956" className="transition hover:text-white">
              +91 96291 28356
            </a>
          </div>
        </div>
        <div className="grid flex-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-white">Quick Links</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition hover:text-white">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-white">Legal</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              {legalLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition hover:text-white">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-white">Connect</p>
            <ul className="mt-3 flex gap-3">
              <li>
                <a
                  href="https://wa.me/919176687956"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-slate-200 transition hover:border-white hover:text-white"
                  aria-label="WhatsApp"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                    <path d="M12 .5C5.65.5.5 5.65.5 12c0 2.04.53 3.98 1.52 5.72L.5 23.5l5.92-1.53A11.44 11.44 0 0012 23.5c6.35 0 11.5-5.15 11.5-11.5S18.35.5 12 .5zm0 21c-1.72 0-3.38-.45-4.85-1.31l-.35-.21-3.51.9.94-3.42-.23-.35A9.46 9.46 0 012.5 12C2.5 6.76 6.76 2.5 12 2.5S21.5 6.76 21.5 12 17.24 21.5 12 21.5zm5.2-6.24c-.29-.15-1.72-.85-1.99-.95-.27-.1-.47-.15-.67.15-.2.29-.77.95-.94 1.15-.17.2-.35.22-.64.07-.29-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.05-.17-.29-.02-.45.13-.6.13-.13.29-.35.44-.52.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01s-.52.07-.79.37c-.27.29-1.04 1.02-1.04 2.49 0 1.47 1.06 2.89 1.2 3.08.15.2 2.08 3.18 5.04 4.46 1.77.76 2.46.82 3.34.69.54-.08 1.72-.7 1.97-1.38.25-.68.25-1.26.17-1.38-.07-.12-.26-.2-.55-.35z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/dialtpr"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-slate-200 transition hover:border-white hover:text-white"
                  aria-label="Instagram"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-5 w-5">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="3.5" />
                    <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCUYu_0ytc0K4r-IYMFqo1Mw"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-slate-200 transition hover:border-white hover:text-white"
                  aria-label="YouTube"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                    <path d="M21.6 7.2a2.4 2.4 0 00-1.69-1.7C18.08 5 12 5 12 5s-6.08 0-7.91.5A2.4 2.4 0 002.4 7.2 25.94 25.94 0 002 12a25.94 25.94 0 00.4 4.8 2.4 2.4 0 001.69 1.7C5.92 19 12 19 12 19s6.08 0 7.91-.5a2.4 2.4 0 001.69-1.7 25.94 25.94 0 00.4-4.8 25.94 25.94 0 00-.4-4.8zM10 15.27V8.73L15.5 12z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-slate-400">
        © {year} Dial TPR. Powered by Bagavaan Groups | ATA Services.
      </div>
    </footer>
  );
};

export default Footer;
